<template lang="pug">
  .b2b-page-newuserentities
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='16')
            div {{ $t('users.createuser.entitiesuser.title', { username: this.modifyUserSession.username } ) }}
      ods-table(
            :data='userEntities',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnterUserEntity',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='projectName',
              :label='$t("user_detail.user_entity_table.project_name")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='partyTaxIdentificationNumber',
              :label='$t("user_detail.user_entity_table.party_tax_identification_number")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='centreCode',
              :label='$t("user_detail.user_entity_table.centre_code")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              label='',
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='!isDuplication'
                  type='neutral',
                  icon='ods-icon-close',
                  @click='removeUserEntity(scope.$index)')
    ods-row.form-actions
      ods-col(:span='24')
        ods-button(
          type='primary',
          @click='goPermissionsUser()')
          | {{ $t('buttons.btnNext') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-newuserentities',
  mixins: [Utils],
  data () {
    return {
      projectSelected: 'Todos',
      partySelected: 'Todos',
      centreSelected: 'Todos',
      // ENTIDADES DE USUARIO
      userEntities: [],
      currentRowUserEntity: {},
      isDuplication: false
    }
  },

  props: {
    duplicateUserData: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters(['modifyUserSession'])
  },

  methods: {
    ...mapActions([
      'getOptionsService',
      'getPartiesByProject',
      'getCentresByParty',
      'deleteUserEntity',
      'getUserEntities'
    ]),

    handleCellMouseEnterUserEntity (row, column, cell, event) {
      this.currentRowUserEntity = row
    },

    goPermissionsUser () {
      this.$emit('update', 3)
    },

    async removeUserEntity () {
      if (this.userEntities.length === 1) {
        this.$notify({
          title: this.$t('user_detail.notify.delete_user_entityko'),
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
      }
      // Solo se eliminaran si hay mas de un elemento
      if (this.userEntities.length > 1) {
        try {
          this.$confirm(this.$t('user_detail.confirm.title_delete_user_entity'), {
            confirmButtonText: this.$t('user_detail.confirm.confirm_button_delete_user_entity'),
            showCancelButton: false,
            center: true,
            iconClass: 'ods-icon-warning'
          }).then(async () => {
            const load = this.$loading({
              lock: true,
              text: this.$t('user_detail.load.delete_user_entity')
            })
            const dataQuery = {
              userId: this.modifyUserSession.usuario.id,
              entityId: this.currentRowUserEntity.id
            }
            await this.deleteUserEntity(dataQuery)
            await this.getUserEntitiesOnDatabase()
            load.close()
            this.$notify({
              title: this.$t('user_detail.notify.delete_user_entity'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          }).catch(() => {})
        } catch (error) {
          console.log('removeUserEntity CATCH: ', error)
        }
      }
    },

    async getUserEntitiesOnDatabase () {
      try {
        // Obtenemos las entidades de usuario
        if (this.modifyUserSession.usuario && this.modifyUserSession.usuario.id) {
          const dataQuery = {
            userId: this.modifyUserSession.usuario.id
          }
          this.userEntities = await this.getUserEntities(dataQuery)
          // Seteamos en objeto
          this.modifyUserSession.userentities = this.userEntities
          for (const entity of this.userEntities) {
          // Cambiamos las etiquetas para que aparezcan como deseamos en la tabla
            if (entity.projectId === null) entity.projectName = this.$t('user_detail.dialog_add_user_entity.option_all_project')
            if (entity.centreId === null) {
              entity.centreCode = this.$t('user_detail.dialog_add_user_entity.option_all_centre')
            } else {
              entity.centreCode = entity.centreCode + (entity.centreDescription === null ? '' : '-' + entity.centreDescription)
            }
            if (entity.partyId === null) {
              entity.partyTaxIdentificationNumber = this.$t('user_detail.dialog_add_user_entity.option_all_party')
            } else {
              entity.partyTaxIdentificationNumber = entity.partyTradeName + '-' + entity.partyTaxIdentificationNumber
            }
          }
        }
      } catch (error) {
        console.log('getUserMediaOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },
  async created () {
    console.log('B2bNewUserExistEntities', this.modifyUserSession)
    if (this.duplicateUserData !== undefined && this.duplicateUserData.userentities !== undefined) {
      this.userEntities = this.duplicateUserData.userentities
      this.isDuplication = true
    } else {
      this.userEntities = this.modifyUserSession.userentities
    }
    const load = this.$loading({
      lock: true,
      text: this.$t('user_detail.load.init_user_data')
    })
    try {
      this.getUserEntitiesOnDatabase()
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}

</script>

<style lang="scss" scoped>
.b2b-page-newuserentities {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
      .ods-button{
        float: right;
      }
      .ods-button--small.is-round {
        padding: 0px;
      }
    }

    &__body {
      padding: 32px;
      .info {
        padding-bottom: 32px;
      }
      .ods-table{
        th {
          padding: rem(0);
          padding-top: rem(4);

          .cell {
            font-weight: 500;
          }
        }
        &__row{
          .ods-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: 0px;
            i {
              margin-left: 0px;
            }
          }
          .first-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: 10px;
            i {
              margin-left: 0px;
            }
          }
        }
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }

  .collapse {
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button {
      float: right;
    }

    ::v-deep .ods-module {
      &__body {
        padding: 0px;
      }
    }
  }
}
</style>
